function hasPermission(user, roles) {
  return Array.isArray(roles) && Array.isArray(user.clients) && user.clients.some(function (client) {
    return roles.indexOf(client.role) >= 0;
  });
}

export default hasPermission;